<post [postSlug]="postSlug" [external]="external"></post>
